var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"InputLabel"},[_c('div',{staticClass:"InputLabelText"},[_vm._v(_vm._s(_vm.label))]),(_vm.required)?_c('div',{staticClass:"InputLabelRequired"},[_vm._v(_vm._s(_vm.$locale["required"]))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }